import { render } from "./FindCitizenModal.vue?vue&type=template&id=42b67bfc"
import script from "./FindCitizenModal.vue?vue&type=script&lang=js"
export * from "./FindCitizenModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__